export default __webpack_public_path__ + "static/media/website.2373de43.png";